/**
 * TypeBox schemas for PackList and PackItem entities
 */

import { Type, type Static } from 'typebox'
import { UUID, ISODate, type Exact } from './common.js'

// --- PackList ---

export const PackListSchema = Type.Object({
  id: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.String({ maxLength: 500 }),
  category: Type.String({ minLength: 1, maxLength: 50 }),
  isTemplate: Type.Boolean(),
  createdBy: UUID,
  isPublic: Type.Boolean(),
  createdAt: ISODate,
  updatedAt: ISODate,
})
export type PackList = Exact<Static<typeof PackListSchema>>

/** Fields required when creating a pack list */
export const PackListCreateSchema = Type.Object({
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.String({ maxLength: 500 }),
  category: Type.String({ minLength: 1, maxLength: 50 }),
  isTemplate: Type.Boolean(),
  createdBy: UUID,
  isPublic: Type.Boolean(),
})

/** Partial pack list for updates */
export const PackListUpdateSchema = Type.Partial(PackListSchema)

// --- PackItem ---

export const PackItemSchema = Type.Object({
  id: UUID,
  packListId: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.Optional(Type.String()),
  weight: Type.Optional(Type.Number({ minimum: 0 })),
  category: Type.String({ minLength: 1, maxLength: 50 }),
  isEssential: Type.Boolean(),
  quantity: Type.Number({ exclusiveMinimum: 0 }),
  assignedTo: Type.Optional(UUID),
  packed: Type.Boolean(),
  packedAt: Type.Optional(ISODate),
})
export type PackItem = Exact<Static<typeof PackItemSchema>>

/** Fields required when creating a pack item */
export const PackItemCreateSchema = Type.Object({
  packListId: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  category: Type.String({ minLength: 1, maxLength: 50 }),
  isEssential: Type.Boolean(),
  quantity: Type.Number({ exclusiveMinimum: 0 }),
  packed: Type.Boolean(),
})

/** Partial pack item for updates */
export const PackItemUpdateSchema = Type.Partial(PackItemSchema)
